/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SeverityEnum {
    INFO = 'INFO',
    WARNING = 'WARNING',
    ERROR = 'ERROR'
}
